import React, { Component } from "react";
import ErrorBoundary from "../../hoc/errorBoundary/error.js";
import classes from "./riverDiagram.module.scss";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import AreaChartComponent from "../../components/UI/charts/area/area.js";
import PieChartComponent from "../../components/UI/charts/pie/pie.js";
import Information from "../../components/riverDiagram/information/information.js";
import Pollutants from "../../components/riverDiagram/pollutants/pollutants.js";

function RiverDiagram(props) {
  const pollutants = useSelector((state) => state.pollutants, shallowEqual),
    rivers = useSelector((state) => state.home.rivers, shallowEqual),
    riverSearch = props.location.search.slice(1),
    river = rivers[riverSearch],
    riverPollutants = pollutants.rivers[riverSearch],
    choosenChemical = "амоній",
    currentChemical = riverPollutants[choosenChemical],
    maxConsistency = pollutants.chemicals[choosenChemical];

  return (
    <ErrorBoundary>
      <main className={classes.wrapper}>
        <div className={classes.information}>
          <Information
            src={river.src}
            name={river.name}
            informMiddle={river.informMiddle}
          />
          <div className={classes.information__chart}>
            <PieChartComponent />
          </div>
        </div>
        <div className={classes.pollution}>
          <div className={classes.pollution__chart}>
            <AreaChartComponent
              title={choosenChemical}
              currentChemical={currentChemical}
              maxConsistency={maxConsistency}
            />
          </div>
          <Pollutants chemicals={pollutants.chemicals} />
        </div>
      </main>
    </ErrorBoundary>
  );
}

RiverDiagram.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(RiverDiagram);
